import LottieLoader from "./LottieLoader";
import React from "react";

const Loading = () => <LottieLoader
    loop={true}
    width={60}
    height={60}
    src={require("../../assets/lottie/Loading.json")}/>

export default Loading;